module.exports = __webpack_public_path__ + "img/emoji_41.90f09ad7.png";